export enum VerificationStatus {
  Disabled = 'DISABLED',
  Passed = 'PASSED',
  PhoneSetupRequired = 'PHONE_SETUP_REQUIRED',
  PhoneVerificationRequired = 'PHONE_VERIFICATION_REQUIRED',
  TotpSetupRequired="TOTP_SETUP_REQUIRED",
  TotpVerificationRequired="TOTP_VERIFICATION_REQUIRED"
}
